<!-- Botón para abrir el modal -->
<p-button 
    [rounded]="onlyIcon"
    [icon]="onlyIcon ? 'pi pi-image' : 'pi pi-image'"
    [iconPos]="onlyIcon ? 'left' : 'right'"
    [label]="onlyIcon ? undefined : 'Subir Fotografía Digital'"
    styleClass="p-button-info"
    (click)="openImageUploaderModal()"
    [title] = "onlyIcon ? 'Subir Fotografía Digital' : null"
    [disabled]="disabled">
</p-button>

<!-- Modal que contiene el componente de subida y edición de imagen -->
<p-dialog [(visible)]="showUploaderModal" [closable]="false" [modal]="true" [style]="{ width: '90vw', cursor: 'default' }"
    styleClass="sm:w-full md:w-8 md:max-w-30rem p-2">

    <!-- Contenido del uploader -->
    <div class="uploader-container">
        
        <!-- Input de tipo file oculto -->
        <input #fileInput type="file" class="input-upload" accept="image/*" (change)="onFileSelected($event)" hidden />

        <!-- Botón de PrimeNG que activa el input -->
        <p-button icon="pi pi-camera" class="custom-file-upload-btn" [rounded]="true"
            (click)="fileInput.click()">
        </p-button>

        <!-- Contenedor con el canvas -->
        <div class="canvas-container" [style.width.px]="CANVAS_WIDTH * 1.25" [style.height.px]="CANVAS_HEIGHT * 1.25">
            <canvas #previewCanvas width="{{CANVAS_WIDTH}}" height="{{CANVAS_HEIGHT}}"></canvas>
            <div class="decorator" [ngClass]="estado()" [style.width.px]="CANVAS_WIDTH * 0.95"
                [style.height.px]="CANVAS_HEIGHT * 0.95">
            </div>

            @if (estado() === ConstEstados.PROCESANDO || estado() === ConstEstados.FINALIZADO) {
            <div class="decoratorHover" [style.width.px]="CANVAS_WIDTH * 1.01" [style.height.px]="CANVAS_HEIGHT * 1.01">
                <div class="decorator-text">
                    {{ estado() !== ConstEstados.FINALIZADO ? 'Recortando imagen' : 'Recorte de imagen finalizado' }}
                </div>
            </div>
            }
        </div>

        

        <!-- Botones de acción -->
        <div class="action-buttons">
            <p-button 
                class="action-button-item btn-cerrar"
                label="Cerrar"
                [type]="'button'" 
                [styleClass]="'btn-procesar p-button-outlined'"

                [style.width.%]="100"
                [style]="{ 'flex': '1' }"

                (click)="closeUploaderModal()">
            </p-button>

            <p-button 
                class="action-button-item btn-procesar"
                icon="pi pi-sparkles" 
                label="Procesar"
                [type]="'button'"
                [iconPos]="'right'"
                [loading]="estado() === ConstEstados.PROCESANDO"
                [rounded]="false" 
                [disabled]="estado() !== ConstEstados.EDITANDO"

                [style.width.%]="100"
                [style]="{ 'flex': '1' }"

                (click)="processAndEmitImage()">
            </p-button>
        </div>

        
        <!-- Opciones adicionales -->
        <div class="mt-4 flex align-items-center gap-3" *ngIf="allowDownload">
            <label for="downloadCheckbox">¿Descargar imagen automáticamente?</label>
            <input type="checkbox" id="downloadCheckbox" [checked]="downloadImageToo()"
                (change)="onDownloadCheckboxChange($event)" />
        </div>
    </div>
</p-dialog>